<template>
    <footer class="footer" role="contentinfo">
      <div class="container">
        <div class="social-links mt-3 mb-3 text-center">
          <!-- <a href="#" class="facebook text-center"
            ><i class="la la-facebook"></i
          ></a> -->
          <a href="https://twitter.com/hideapikey.com" target="_blank" class="twitter text-center"
            ><i class="la la-twitter"></i
          ></a>
          <!-- <a href="#" class="instagram text-center"
            ><i class="lab la-linkedin-in"></i
          ></a>
          <a href="#" class="youtube text-center"
            ><i class="la la-instagram"></i
          ></a> -->
        </div>
        <div class="row justify-content-center text-center">
          <div class="col-md-7">
            <p class="copyright">
              {{new Date().getFullYear()}} &copy; Copyright Division by Heroes e.U. All Rights Reserved
            </p>
          </div>
        </div>
        <div class="row justify-content-center text-center">
          <div class="col-md-7">
            <p class="copyright">
             <a href="https://www.divisionbyheroes.com/impressum/" target="_blank" rel="noopener" class="nav-link">Impressum</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
